"use client";

import { ButtonFixed, ButtonFixedText, Spinner } from "@dafiti/closet-ui";
import { useTranslations } from "next-intl";

import { useFiltersStore } from "../../../stores/filters.store";
import type { Facet } from "../../../types/filters.type";
import { FilterContent } from "../FilterContent";

interface FilterDrillScreenProps {
  facet: Facet;
  onConfirm: () => Promise<void>;
  onLabelChange?: (label: string) => void;
  onBackHandlerChange?: (handler: (() => void) | null) => void;
}

export function FilterDrillScreen({
  facet,
  onConfirm,
  onLabelChange,
  onBackHandlerChange,
}: FilterDrillScreenProps) {
  const t = useTranslations("catalog");
  const isLiveUpdateLoading = useFiltersStore((s) => s.isLiveUpdateLoading);

  return (
    <div
      className="flex flex-1 flex-col min-h-0"
      data-testid="filter-drill-screen"
    >
      <div
        className="flex flex-col flex-1 min-h-0"
        data-testid="filter-search-wrapper"
      >
        <FilterContent
          facet={facet}
          onLabelChange={onLabelChange}
          onBackHandlerChange={onBackHandlerChange}
        />
      </div>

      <div className="flex -mx-6">
        <ButtonFixed
          onClick={onConfirm}
          disabled={isLiveUpdateLoading}
          aria-label={t("actions.selectFilter")}
          data-testid="select-filter-button"
          className="relative"
        >
          {isLiveUpdateLoading ? (
            <Spinner
              data-testid="select-filter-loading"
              className="text-white"
              size="lg"
              ariaLabel={t("common.loadingLabel")}
            />
          ) : (
            <ButtonFixedText className="font-normal">
              {t("actions.selectFilter")}
            </ButtonFixedText>
          )}
        </ButtonFixed>
      </div>
    </div>
  );
}
